import { render } from "./SandboxJobList.vue?vue&type=template&id=0e7d79ee&scoped=true"
import script from "./SandboxJobList.vue?vue&type=script&lang=js"
export * from "./SandboxJobList.vue?vue&type=script&lang=js"

import "./SandboxJobList.vue?vue&type=style&index=0&id=0e7d79ee&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7d79ee"]])

export default __exports__